import { render } from "./TripPaymentConfirmation.vue?vue&type=template&id=2c46e1fe&lang=pug"
import script from "./TripPaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./TripPaymentConfirmation.vue?vue&type=script&lang=ts"
script.render = render

export default script